import * as React from 'react';

import a11yKeyPress from 'js/lib/a11yKeyPress';
import connectToRouter from 'js/lib/connectToRouter';
import type { InjectedRouter } from 'js/lib/connectToRouter';

import { switchAuthModalTo } from 'bundles/front-page/utils';
import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';
import type { TrackingProps } from 'bundles/page/components/TrackedLink2';

type PropsFromCaller = Partial<
  TrackingProps & {
    className: string;
    selected: boolean;
  }
>;

type PropsFromRouter = {
  router: InjectedRouter;
};

type PropsToComponent = PropsFromRouter & PropsFromCaller;

class LoginLink extends React.Component<PropsToComponent> {
  link: HTMLAnchorElement | null = null;

  componentDidMount() {
    if (this.link && this.props.selected) {
      this.link.focus();
    }
  }

  onClick = () => {
    const { router } = this.props;

    switchAuthModalTo('login', router);
  };

  render() {
    const { className, children } = this.props;
    return (
      <TrackedLink2
        {...this.props}
        trackingName="login"
        href="#"
        onClick={this.onClick}
        onKeyPress={(event: React.SyntheticEvent<HTMLAnchorElement, Event>) => a11yKeyPress(event, this.onClick)}
        className={className}
        data-e2e="login-nav-link"
        refAlt={(ref) => {
          this.link = ref;
        }}
        linkType="a"
      >
        {children}
      </TrackedLink2>
    );
  }
}

export default connectToRouter<PropsToComponent, PropsFromCaller>((router) => ({ router }))(LoginLink);
